import * as yup from 'yup';

const uuidRegex =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

declare module 'yup' {
  interface StringSchema {
    matchesUuid<T extends string>(errorMessage?: string): StringSchema<T>;
  }
}

yup.addMethod(
  yup.string,
  'matchesUuid',
  function (this: yup.StringSchema, errorMessage?: string) {
    return this.test(
      'matches-uuid',
      errorMessage ?? 'Il valore non è un UUID valido',
      value => {
        if (!value) return true;
        return uuidRegex.test(value);
      },
    );
  },
);
